import { useContext } from "react";
import { MasterDataContext } from "../contexts/MasterDataContext";

export const useMasterData = () => useContext(MasterDataContext);
